// extracted by mini-css-extract-plugin
export default {"loader":"FileViewer_loader__46wFE"};